import { IEmailAIExtractedData } from "@/types/common";
import React, { useState } from "react";
import BaseDialog from "@/components/BaseDialog";
import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";

const ViewContentDialogButton = ({
  field,
}: {
  field: IEmailAIExtractedData;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <BaseDialog
      trigger={
        <Text color="brand.solid" cursor="pointer">
          Click to view
        </Text>
      }
      title={"Notes"}
      actionButtons={
        <Button variant="outline" onClick={() => setOpen(false)}>
          Close
        </Button>
      }
      open={open}
      setOpen={setOpen}
    >
      <Box
        p={2}
        pl={5}
        border="1px solid"
        borderColor="border"
        rounded="md"
        minH={300}
      >
        <div
          style={{
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: 400,
            color: "#323232",
          }}
        >
          {field?.notes?.split("\n").map((line, idx) => (
            <li key={idx} style={{ marginBottom: 8 }}>
              {line}
            </li>
          ))}
        </div>
      </Box>
    </BaseDialog>
  );
};

export default ViewContentDialogButton;
